/** Current consent cookie version. Bump to re-show banner when categories change. */
export const CONSENT_VERSION = 1;

export const CONSENT_COOKIE_NAME = "fu-consent";

export type ConsentMode = "disabled" | "built-in";
export type BannerStyle = "bottom-bar" | "overlay";

export interface ConsentState {
    analytics: boolean;
    marketing: boolean;
    timestamp: string;
    version: number;
}

export interface ConsentContextValue {
    /** Current consent state, null if no consent given yet */
    consent: ConsentState | null;
    /** Whether the preferences panel is open */
    isPreferencesOpen: boolean;
    /** Update consent preferences */
    updateConsent: (analytics: boolean, marketing: boolean) => void;
    /** Accept all non-essential cookies */
    acceptAll: () => void;
    /** Reject all non-essential cookies */
    rejectAll: () => void;
    /** Open the preferences panel (used by footer link) */
    openPreferences: () => void;
    /** Close the preferences panel */
    closePreferences: () => void;
}
